import React from 'react';
import PropTypes from 'prop-types';
import CategoryWrapper from 'cms/blog/Main/CategoryWrapper';
import CategoryCard from 'cms/blog/Main/CategoryCard';

const Articles = ({articles}) => {
  const {title, permanlink, viewMore, posts} = articles;

  return (
    <div className="mt-6">
      <CategoryWrapper
        title={title}
        link={permanlink}
        viewMoreText={viewMore}
      >
        <CategoryCard posts={posts} />
      </CategoryWrapper>
    </div>
  );
};

Articles.propTypes = {
  articles: PropTypes.shape({
    title: PropTypes.string.isRequired,
    permanlink: PropTypes.string.isRequired,
    viewMore: PropTypes.string.isRequired,
    posts: PropTypes.array.isRequired
  })
};

export default Articles;
